export const plan = {
    labels: {
        affiliate_accounts: "Affiliate Accounts",
        plan: "Plan",
        plans: "Plans",
        invoice: "Invoice",
        invoices: "Invoices",
        my_account: "My Account",
        my_plans: "My Plans",
        my_signature: "My Subscription",
        my_invoices: "My Invoices",
        frequency: "Frequency (in days)",
        frequency_short: "Frequency",
        plan_edit: "Edit Plan",
    },
    modals: {
        titles: {
            plan_add: "Add Plan",
            plan_remove: "Remove Plan",
        },
        messages: {
            plan_remove: "Are you sure you want to remove the plan <strong>{name}</strong>?<br/>This action cannot be undone.",
        }
    },
    texts: {
        account_empty: "You don't have an account yet.",
        affiliate_accounts: "You don't have access to other accounts yet.",
        invoice_empty: "You don't have any invoices yet.",
        signature_empty: "You don't have a subscription yet.",
    },
};
